export default __webpack_public_path__ + "static/testimonials-bg-br-1d89681163226eb02aec1d4318c2a0bd.svg";